import { Button } from '@/components/ui/button';
import useMultidietSetupStore from '@/features/multidiet-picker/store/multidiet-picker.store';
import { MultidietSetupVariantType } from '@/features/multidiet-picker/types/multidiet-setup.type';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';

export const MultidietVariantsItem = ({
  size = 'small',
  isBestOffer = false,
  layout = 'page',
  variant,
}: {
  size?: 'small' | 'large';
  isBestOffer?: boolean;
  layout?: 'page' | 'popup';
  variant: MultidietSetupVariantType;
}) => {
  const t = useTranslations();
  const params = useSearchParams();
  const type = params.get('type');

  return (
    <div
      className={cn(
        'rounded-xl relative border-2 ',
        layout === 'page' ? 'bg-white' : 'bg-brand-grey1',
        size === 'large' ? 'px-5 py-7' : 'px-5 py-6',
        isBestOffer
          ? ' border-brand-red basis-[38%]'
          : 'border-transparent basis-[31%]',
        type && type === variant.type
          ? 'border-brand-green-light'
          : type
            ? 'border-transparent'
            : '',
      )}
    >
      {isBestOffer && (
        <p className='absolute -top-3.5 right-4 bg-brand-red tracking-wider text-white px-3 py-1.5 text-[11px] font-medium uppercase rounded-4xl'>
          {t('multidiet-picker.best-offer')}
        </p>
      )}
      <div>
        <header className='mb-2.5'>
          <p
            className={cn(
              ' text-brand-green3 mb-2',
              size === 'large' ? 'text-sm' : 'text-xs',
            )}
          >
            {t('multidiet-picker.average-price')}
          </p>
          <h3
            className={cn(
              'transition-all duration-300 mb-1',
              size === 'large' ? 'text-xl leading-7' : 'text-base leading-6',
            )}
          >
            {t.rich('multidiet-picker.price-per-day', {
              price: (chunks) => (
                <span
                  className={cn(
                    'font-medium px-1 ',
                    size === 'large' ? 'text-2xl' : 'text-base',
                  )}
                >
                  {chunks}
                </span>
              ),
              value: variant.price,
            })}
          </h3>
          {variant.discount && (
            <p
              className={cn(
                'font-medium mb-4',
                size === 'large' ? 'text-sm' : 'text-xs',
              )}
            >
              {t(`multidiet-picker.description.${variant.type}`)}
            </p>
          )}
        </header>
        <Button
          variant='secondary'
          size='lg'
          className={cn('w-full', size === 'large' ? 'h-12' : 'h-11')}
          data-dietvariant={JSON.stringify(variant)}
          type='submit'
        >
          {t('multidiet-picker.choose')}
        </Button>
        <div
          className={cn(
            size === 'large' ? 'text-sm mt-3 pt-2' : 'text-xs mt-2 pt-1.5',
            'leading-5 border-t border-brand-grey2 ',
          )}
        >
          <p
            dangerouslySetInnerHTML={{
              __html: t.raw(`multidiet-picker.bonus.${variant.type}`),
            }}
          />
        </div>
      </div>
    </div>
  );
};
